export type InventoryItemModalSection =
  | 'general'
  | 'price'
  | 'availability'
  | 'media'
  | 'product-details';

export const SECTIONS: { key: InventoryItemModalSection; label: string }[] = [
  { key: 'general', label: 'inventory.modalHeaders.general' },
  { key: 'price', label: 'inventory.modalHeaders.price' },
  { key: 'availability', label: 'inventory.modalHeaders.availability' },
  { key: 'media', label: 'inventory.modalHeaders.media' },
  { key: 'product-details', label: 'inventory.modalHeaders.productDetails' },
];

export type InventoryModalMode = 'view' | 'create';
